import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { filter, map } from 'rxjs/operators';
import { Action } from 'redux';
import { SetActiveArtist } from '../action-creators';
import { SET_ACTIVE_ARTIST } from '../actions';
import { setLastActiveArtistId } from '@webapp/utils/artists/last-active';
import * as artists from '@webapp/sdk/artists';
import { NoOp } from '@webapp/store/ui/action-creators';

export const updateLastActiveArtistEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, SetActiveArtist>(SET_ACTIVE_ARTIST),
    filter((action) => !!action.artist.id),
    map((action) => {
      setLastActiveArtistId(action.artist.id);
      artists.setLastAccess(action.artist.id);
      return new NoOp();
    })
  );
